const pageNameKey = "noGatewaysDetectedView";

export const noGatewaysDetectedViewEn = {
  [pageNameKey]: {
    noGatewaysDetectedSubtitle: "Gateways List",
    noGatewaysConnectedHint: "No Gateways connected",
    noGatewaysDetectedTitle: "Add your first Gateway to get started",
    noGatewaysDetectedButtonText: "Add Gateway",
    noGatewaysDetectedQuestion: "Multiple Gateways?",
    noGatewaysDetectedAnswer:
      "If you need to register multiple gateways, you'll receive a file to upload to your profile, allowing you to automatically register all devices at once.",
    noGatewaysDetectedUploadButtonText: "Upload here",
    noGatewaysDetectedLearnMoreButtonText: "Learn more",
  },
};

export const noGatewaysDetectedViewPtBr = {
  [pageNameKey]: {
    noGatewaysDetectedSubtitle: "Lista de gateways",
    noGatewaysConnectedHint: "Nenhum gateway conectado",
    noGatewaysDetectedTitle: "Adicione seu primeiro Gateway para começar",
    noGatewaysDetectedButtonText: "Adicionar gateway",
    noGatewaysDetectedQuestion: "Vários gateways?",
    noGatewaysDetectedAnswer:
      "Se você precisar registrar vários gateways, receberá um arquivo para fazer upload no seu perfil, permitindo registrar automaticamente todos os dispositivos de uma vez só .",
    noGatewaysDetectedUploadButtonText: "Envie aqui",
    noGatewaysDetectedLearnMoreButtonText: "Saiba mais",
  },
};

export const noGatewaysDetectedViewDe = {
  [pageNameKey]: {
    noGatewaysDetectedSubtitle: "Gateways List",
    noGatewaysConnectedHint: "Keine Gateways verbunden",
    noGatewaysDetectedTitle:
      "Fügen Sie Ihr erstes Gateway hinzu, um zu beginnen",
    noGatewaysDetectedButtonText: "Gateway hinzufügen",
    noGatewaysDetectedQuestion: "Mehrere Gateways?",
    noGatewaysDetectedAnswer:
      "Wenn Sie mehrere Gateways registrieren müssen, erhalten Sie eine Datei, die Sie in Ihr Profil hochladen können, damit Sie alle Geräte auf einmal automatisch registrieren können.",
    noGatewaysDetectedUploadButtonText: "Hier hochladen",
    noGatewaysDetectedLearnMoreButtonText: "Erfahren Sie mehr",
  },
};

export const noGatewaysDetectedViewZhHans = {
  [pageNameKey]: {
    noGatewaysDetectedSubtitle: "网关列表",
    noGatewaysConnectedHint: "没有连接的网关",
    noGatewaysDetectedTitle: "添加您的第一个网关以开始",
    noGatewaysDetectedButtonText: "添加网关",
    noGatewaysDetectedQuestion: "多个网关？",
    noGatewaysDetectedAnswer:
      "如果您需要注册多个网关，您将收到一个文件上传到您的个人资料中，从而允许您一次性自动注册所有设备。",
    noGatewaysDetectedUploadButtonText: "在这里上传",
    noGatewaysDetectedLearnMoreButtonText: "了解更多",
  },
};

export const noGatewaysDetectedViewIt = {
  [pageNameKey]: {
    noGatewaysDetectedSubtitle: "Elenco gateway",
    noGatewaysConnectedHint: "Nessun gateway connesso",
    noGatewaysDetectedTitle: "Aggiungi il tuo primo gateway per iniziare",
    noGatewaysDetectedButtonText: "Aggiungi gateway",
    noGatewaysDetectedQuestion: "Più gateway?",
    noGatewaysDetectedAnswer:
      "Se devi registrare più gateway, ti verrà fornito un file da caricare nel tuo profilo, che ti permetterà di registrare automaticamente tutti i dispositivi contemporaneamente.",
    noGatewaysDetectedUploadButtonText: "Carica qui",
    noGatewaysDetectedLearnMoreButtonText: "Scopri di più",
  },
};

export const noGatewaysDetectedViewEs = {
  [pageNameKey]: {
    noGatewaysDetectedSubtitle: "Lista de gateways",
    noGatewaysConnectedHint: "No hay gateways conectados",
    noGatewaysDetectedTitle: "Añade tu primer gateway para empezar",
    noGatewaysDetectedButtonText: "Agregar gateway",
    noGatewaysDetectedQuestion: "¿Múltiples gateways?",
    noGatewaysDetectedAnswer:
      "Si necesitas registrar varios gateways, recibirás un archivo para cargar en tu perfil, lo que te permitirá registrar automáticamente todos los dispositivos a la vez.",
    noGatewaysDetectedUploadButtonText: "Sube aquí",
    noGatewaysDetectedLearnMoreButtonText: "Más información",
  },
};

export const noGatewaysDetectedViewNl = {
  [pageNameKey]: {
    noGatewaysConnectedHint: "Geen gateways verbonden",
    noGatewaysDetectedAnswer:
      "Als u meerdere gateways moet registreren, ontvangt u een bestand dat u naar uw profiel kunt uploaden, zodat u alle apparaten in één keer automatisch kunt registreren.",
    noGatewaysDetectedButtonText: "Gateway toevoegen",
    noGatewaysDetectedQuestion: "Meerdere gateways?",
    noGatewaysDetectedSubtitle: "Gatewaylijst",
    noGatewaysDetectedTitle: "Voeg uw eerste gateway toe om te beginnen",
    noGatewaysDetectedLearnMoreButtonText: "Meer informatie",
    noGatewaysDetectedUploadButtonText: "Hier uploaden",
  },
};

export const noGatewaysDetectedViewTr = {
  [pageNameKey]: {
    noGatewaysConnectedHint: "Hiçbir Ağ Geçidi bağlı değil",
    noGatewaysDetectedAnswer:
      "Birden fazla ağ geçidini kaydetmeniz gerekiyorsa, profilinize yüklenecek bir dosya alacaksınız; bu, tüm cihazları aynı anda otomatik olarak kaydetmenize olanak tanır.",
    noGatewaysDetectedButtonText: "Ağ Geçidi Ekle",
    noGatewaysDetectedLearnMoreButtonText: "Daha fazla bilgi edin",
    noGatewaysDetectedQuestion: "Çoklu Ağ Geçitleri mi?",
    noGatewaysDetectedSubtitle: "Ağ Geçitleri Listesi",
    noGatewaysDetectedTitle: "Başlamak için ilk Ağ Geçidinizi ekleyin",
    noGatewaysDetectedUploadButtonText: "Buraya yükleyin",
  },
};
